module.exports = __webpack_public_path__ + "img/heart.32ef9118.svg";